

























































import Component from 'vue-class-component';
import {ISort} from '@/entities/sort.interface';
import {IPreferredDomain, IPreferredDomainView} from '@/entities/preferred-domains';
import {MasterPage} from '@/components/base/master/master-page';
import preferredDomainApi from '@/api/preferred-domain.api';
import {mapGetters} from 'vuex';
import * as types from '@/store/types';
import {IUpdatePreferredDomainHidden} from '@/entities/preferred-domains/update-preferred-domain-hidden';
import {IConfirm} from '@/entities';
import {CLOSE_CONFIRM} from '@/store/types';

@Component({
    computed: mapGetters({
        superadminPermissions: types.AUTH_HAS_SUPERADMIN_PERMISSIONS,
    })
})
export default class PreferredDomainMasterPage extends MasterPage {
    public items: IPreferredDomainView[] = [];

    protected defaultSort: ISort = {
        field: 'id',
        asc: true
    };

    public created() {
        this.search();
    }

    public async search() {
        this.loading = true;
        this.items = [];

        try {
            this.items = await preferredDomainApi.listWithCompanies();
        } finally {
            this.loading = false;
        }
    }

    public activate(domain: IPreferredDomain) {
        this._updateHidden([domain.id], {hidden: false}, 'Are you sure to activate domain?');
    }

    public hide(domain: IPreferredDomain) {
        if (this.items.filter((d) => {
            return !d.hidden;
        }).length <= 1) {
            this._needActiveDomain();
            return;
        }
        this._updateHidden([domain.id], {hidden: true},
            'Are you sure to hide domain?');

    }

    private _updateHidden(
        ids: number[],
        model: IUpdatePreferredDomainHidden,
        heading: string = 'Are you sure?'
    ) {
        let afterFn = (closeFn: () => void) => {
            preferredDomainApi
                .updateStatusBatch(ids, model)
                .then(() => {
                    this._updateItemsHidden(ids, model);
                    closeFn();
                })
                .catch(() => closeFn());
        };

        let payload: IConfirm = {
            heading,
            afterFn
        };

        this.$store.dispatch(types.SHOW_CONFIRM, payload);
    }

    private _needActiveDomain() {
        let afterFn = (closeFn: () => void) => {
            closeFn();
        };
        let payload: IConfirm = {
            heading: 'Need at least one active domain',
            cancelBtn: false,
            afterFn
        };
        // this.$store.dispatch(types.CLOSE_CONFIRM, payload);
        this.$store.dispatch(types.SHOW_CONFIRM, payload);
    }

    private _updateItemsHidden(ids: number[], model: IUpdatePreferredDomainHidden) {
        this.items = this.items.map((item) => {
            if (ids.indexOf(item.id) === -1) {
                return item;
            } else {
                return {...item, ...model};
            }
        });
    }
}
